import { Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { ExternalSupplierInfo } from 'contacts/components';
import { IContactGroupAddress } from 'contacts/types';
import { InfoCard } from 'core/components';
import { IInfoCardLine } from 'core/types';
import { Color, Level } from 'theme/enums';

interface IProps {
  vendor: IContactGroupAddress;
}

export const AlternateVendorDetails = ({ vendor }: IProps) => {
  const { t } = useTranslation();

  const detailItems: IInfoCardLine[] = [
    {
      label: t('labelSupplierName'),
      value: vendor?.contactGroup?.alternateVendorName,
    },
    {
      label: t('labelSupplierNumber'),
      value: vendor?.contactGroup?.alternateVendorId,
    },
    {
      label: t('labelAPNumber'),
      value: vendor?.accountsPayableId,
    },
  ];

  return (
    <Stack sx={{ gap: 2, overflowY: 'auto', maxHeight: '100%' }}>
      <Typography level={Level.TITLE_MD} color={Color.PRIMARY} sx={{ textWrap: 'wrap' }}>
        {vendor?.name}
      </Typography>

      <InfoCard title={t('titleDetails')} items={detailItems} filterEmptyLines />

      <ExternalSupplierInfo
        primaryContact={vendor?.primaryContact ?? null}
        purchasingAttributes={vendor?.purchasingAttributes ?? []}
      />
    </Stack>
  );
};
